import classNames from 'classnames'

import Loader from 'Root/Loader'

import styles from './index.module.css'

interface Props {
  children: React.ReactNode
  className?: string
  disabled?: boolean
  processing?: boolean
  [props: string]: any
}

const Button = ({
  children,
  className,
  disabled = false,
  processing = false,
  ...props
}: Props) => (
  <button
    {...props}
    className={classNames(styles.button, className)}
    disabled={disabled || processing}
  >
    {processing ? <Loader className="h-6 w-6 mx-auto" /> : children}
  </button>
)

export default Button
